import { isCustomerQuote, isQuote, type CustomerQuote, type Quote } from '@talos/kyoko';
import { useReducer } from 'react';
import { modifyFixingSliceReducer, type ModifyFixingState } from './modifyFixingSlice';
import { customerQuoteToModifyFixingState, quoteToModifyFixingState } from './stateBuilders';

export const useModifyFixingState = (quote: Quote | CustomerQuote) => {
  const [state, dispatch] = useReducer(modifyFixingSliceReducer, undefined, (): ModifyFixingState => {
    if (isQuote(quote)) {
      return quoteToModifyFixingState(quote);
    }
    if (isCustomerQuote(quote)) {
      return customerQuoteToModifyFixingState(quote);
    }

    throw new Error('Unsupported quote type in ModifyFixingDialogV2');
  });

  return { state, dispatch };
};
